<template>
  <div>
    <a-card
      :title="$t('k_12dfe79b')"
      :bordered="false"
    >
      <apply-form
        ref="applyForm"
        :project-id="projectId"
        :env="env"
        :data="payload"
        :flow-config="flowConfig"
        :editable="matchHandler && entity.flowStatus === 'processing'"
        mode="approval"
      />
      <div v-if="entity.flowStatus === 'processing' && !pluginDisableDefaultAction">
        <a-form-model>
          <div v-if="matchHandler">
            <a-form-model-item
              :label="$t('k_68a001fc')"
              :label-col="{ span: 8 }"
              :wrapper-col="{ span: 14 }"
            >
              <a-textarea
                v-model="comment"
                :placeholder="$t('k_68a001fc')"
              />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ offset: 8 }">
              <a-button
                type="primary"
                :disabled="!!approving"
                :icon="approving === 'pass' ? 'loading' : ''"
                @click="pass"
              >
                {{ $t("k_e5d094ae") }}
              </a-button>
              <a-button
                style="margin-left:12px"
                :disabled="!!approving"
                :icon="approving === 'reject' ? 'loading' : ''"
                @click="reject"
              >
                {{ $t("k_4ad83ff3") }}
              </a-button>
            </a-form-model-item>
          </div>
          <div v-else-if="isAdmin">
            <a-alert
              banner
              :message="$t('k_1c76407b')"
            />
            <a-form-model-item>
              <public-w-dept-rtx-select
                type="staffs"
                multiple
                :placeholder="$t('k_fbcda0d0')"
                :value="handlers"
                @change="rtxChange"
              />
              <a-button
                type="primary"
                @click="assignHandlers"
              >
                {{ $t("k_5fa63f3c") }}
              </a-button>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import { getUserId } from '@utils/userInfo';
import ApplyForm from './ApplyForm.vue';
import { workflowEntityApi } from '@/services';
import { getWorkflowNotificationPluginList } from '@pages/modules/workflow/config/utils';

export default {
  components: {
    ApplyForm,
  },
  inject: {
    ctx: 'ctx',
  },
  props: {
    projectId: {
      type: String,
      default: '',
    },
    env: {
      type: String,
      default: '',
    },
    entity: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      handlers: [],
      comment: '',
      approving: '',
    };
  },
  computed: {
    payload() {
      if (!this.entity) return null;
      const { payload } = this.entity;
      return JSON.parse(payload);
    },
    flowConfig() {
      if (!this.entity) return null;
      const { flowConf } = this.entity;
      return JSON.parse(flowConf);
    },
    matchHandler() {
      const user = getUserId();
      if (!this.entity) return false;
      return this.entity.handlers.split(',').includes(user);
    },
    isAdmin() {
      return this.ctx?.user?.isAdmin;
    },
    // 插件可以禁止默认的审批行为，全权交由第三方进行审批处理
    pluginDisableDefaultAction() {
      const pluginId = this.flowConfig?.notifyPluginId;
      if (!pluginId) return false;
      const plugin = getWorkflowNotificationPluginList().find(x => x.id === pluginId);
      return !!plugin?.disableDefaultAction;
    },
  },
  methods: {
    async rtxChange(value) {
      this.handlers = value;
    },
    async assignHandlers() {
      if (!this.handlers.length) {
        message.warn($t('k_3c8f8c7e'));
        return;
      }
      const { _id: id } = this.entity;

      try {
        const handlers = this.handlers.join(',');
        await workflowEntityApi.assignHandlers(this.projectId, this.env, id, handlers);
        this.$root.$emit('workflow.assign');
        message.success($t('k_cc570dc7'));
        this.handlers = [];
        this.$set(this.entity, 'handlers', handlers);
      } catch (err) {
        const msg = $t('k_edb405d4');
        message.error(msg);
        console.error(msg, err);
      }
    },
    async pass() {
      const role = this.$refs.applyForm.selectedRoles.join(',');
      if (!role) {
        message.error($t('k_d1554fe'));
        return;
      }
      const expireAt = +this.$refs.applyForm.form.expireAt || undefined ;
      await this.transition('pass', this.comment, { role, expireAt });
    },
    async reject() {
      await this.transition('reject', this.comment);
    },
    async transition(operation, comment, payload) {
      const { _id: id, status } = this.entity;
      this.approving = operation;
      try {
        await workflowEntityApi.transition(
          this.projectId,
          this.env,
          id,
          { currentStatus: status, operation, comment, payload },
        );
        this.$router.go(0);
      } catch (error) {
        const msg = $t('k_f07c490a');
        console.error(msg, error);
        message.error(msg);
      } finally {
        setTimeout(() => this.approving = '', 1000);
      }
    },
  },
};
</script>
